export const firebaseConfig = {
  apiKey: "AIzaSyArvbpaZ10zQwCbJocN7U8u0HhWgDnVPfQ",
  authDomain: "mbo-checkin.firebaseapp.com",
  projectId: "mbo-checkin",
  storageBucket: "mbo-checkin.appspot.com",
  messagingSenderId: "687942414628",
  appId: "1:687942414628:web:dd165e72357a56875703b1",
  measurementId: "G-9FB95CR7WY",
};
